/**
 * reviews.js — Lebua Thai Customer Reviews
 *
 * THIS IS THE ONLY FILE YOU NEED TO EDIT when adding or updating reviews.
 *
 * To add a new review: copy one block below, paste it at the top of the array,
 * and fill in name, rating (1–5), and review text.
 *
 * To remove a review: delete its block entirely.
 * To hide a review temporarily: set  active: false
 */

const GOOGLE_REVIEW_URL =
  'https://search.google.com/local/writereview?placeid=ChIJIZG3XQ8Z2jERMbd1E9quDKM';

const reviews = [
  {
    name: 'Albert Foodie',
    rating: 5,
    review:
      'Recommended by friend to this restaurant. Very surprising to find good authentic Thai food here. Many promotions, especially the Wednesday night buffet at $38+, definitely value for money. Love the grilled pork jowl. Eating oysters is a different experience following Thai style — they provide self-made red chilli sauce, green chilli sauce, fried scallions, garlic and red chilli. Definitely a different experience.',
    active: true,
  },
  {
    name: 'Zackary Goh',
    rating: 5,
    review:
      'I had an amazing lunch experience at Lebua Thai! Their Thai steam fish was absolutely delightful, perfectly seasoned and so fresh. The Tomyum fried rice was a standout as well, bursting with flavours that truly captured the essence of Thai cuisine. I was pleasantly surprised by the incredible value of their lunch set — a drink, soup, and a delicious main course all at a reasonable price. Can\'t wait to return!',
    active: true,
  },
  {
    name: 'Keith Carter',
    rating: 5,
    review:
      'Great food — clean and refreshing. I really enjoyed eating it, such good quality that I felt happy after the meal. I had the lunch set of basil chicken rice, Thai milk tea and a fresh, zesty soup. The mango sticky rice was presented beautifully. Friendly staff and nice owner, Natty, who brightened up the whole place.',
    active: true,
  },
  {
    name: 'Ms Tran',
    rating: 5,
    review:
      'Great restaurant with Thai cuisine and good quality ingredients. I went here a few times and tried different dishes every time. I especially like the mixed papaya salad and the fresh oysters. Delicious food, beautiful plate decoration, reasonable prices, and great atmosphere. Polite staff and good service. Will come back for sure.',
    active: true,
  },
  {
    name: 'R T',
    rating: 4.5,
    review:
      'I travel to review Thai food in Singapore and Thailand, and very happy to find another gem. My top picks: sun-dried pork, Mooping, Tom Yum seafood. The horfun was good and the crab omelette was nice. Overall the food is really good and prices are very affordable — please support them.',
    active: true,
  },
  {
    name: 'Mike Ong',
    rating: 5,
    review:
      'Very authentic Thai food and pleasant dining experience. The food quality is decent, especially the fried chicken wings and stir fried vegetables. Had a pleasant evening celebrating a family birthday dinner with ample space for big gatherings. Service was very attentive and accommodating. Definitely a hidden gem.',
    active: true,
  },
  {
    name: 'Randy',
    rating: 5,
    review:
      'A gem hidden at Pasir Panjang. One of the best Thai food in town. The food is delicious, comes in generous portions, and is not overly oily or salty — a rarity in Singapore. If you\'re health conscious, there are plenty of vegetable options. The service is fantastic, very attentive, speedy, and always kind. Highly recommended.',
    active: true,
  },
  {
    name: 'Wei Ken Loh',
    rating: 5,
    review:
      'One of the best Thai restaurants I have ever eaten at. The style of cooking is as flavourful as the food in Thailand, food presentation is excellent and customer service was utterly amazing. Would absolutely come back here any time for a fix!',
    active: true,
  },
  {
    name: 'Chin Zhi Hui',
    rating: 5,
    review:
      'The Thai boat noodles were very good and aromatic. It tasted very fresh. The milk tea was also very fragrant as well, which is rare for a usual Thai restaurant.',
    active: true,
  },
  {
    name: 'MDPHDLIFE',
    rating: 5,
    review:
      'The food here is really worth a try! One of the best Thai food I had in Singapore. The basil pork was really another level — hard to describe, come down and try it on your own. The Tom yum soup is really appetising, the right amount of tanginess plus a whole head of quality seafood. Really worth it.',
    active: true,
  },
  {
    name: 'Panravee Yokaew',
    rating: 5,
    review:
      'This is my fifth time visiting. I like all the menu. Tom yum seafood is a must-have. Fried sea bass is superb. Very crispy.',
    active: true,
  },
  {
    name: 'Lee Junkang',
    rating: 5,
    review:
      'Whoever needs their Thai food craving fixed, Lebua Thai is the place to go. Their ingredients are so fresh and the taste is very authentic. Very affordable and staff are very attentive and friendly. They serve a good selection of wines and champagne too! I\'ll certainly recommend friends to dine at Lebua Thai.',
    active: true,
  },
  {
    name: 'Richard Er GueSeng',
    rating: 5,
    review:
      'Delicious authentic Thai food. Ordered pad Thai and Tom yum soup — fabulous. Great promotions available including 1-for-1 draft beer and red wine. Will definitely recommend my friends to this place.',
    active: true,
  },
  {
    name: 'Beom Soo',
    rating: 5,
    review:
      'I\'m glad I tried this Thai restaurant. The Stir Fried Prawn with Curry Powder was outstanding — tender prawns with a delicious runny egg sauce which was so addictive. Great service from Betty, the owner. Food was served quickly. Would definitely come back.',
    active: true,
  },
  {
    name: 'Mei Nah Mong',
    rating: 5,
    review:
      'Real authentic Thai food in Singapore! The prawns are fresh and cooked in a similar way to Song Boon in Bangkok. Beer and wine buy 1 get 1 free — what a great deal! More people should come and support them so we get to enjoy authentic Thai food in Singapore!',
    active: true,
  },
];

export { GOOGLE_REVIEW_URL };
export default reviews;
